import { http } from "@/providers/http";
import { utils } from "@/utils/utils";
export class RenewalFormApi {
  private static INSTANCE = new RenewalFormApi();

  static get instance() {
    return this.INSTANCE;
  }

  // POST for Renewal application
  public RenewalApplicationForm(fillStatus: string, renewalPayLoadData: any) {
    const userDetails = utils.getUserDetails();
    let adminuserDetail: any = localStorage.getItem("admin_user_details");
    if (adminuserDetail) {
      adminuserDetail = JSON.parse(adminuserDetail);
    }
    const data = {
      fillStatus: renewalPayLoadData.fillStatus,
      data: {
        renewalApplicationInformation:
          renewalPayLoadData.renewalApplicationInformation,
        renewalTrainingInformation:
          renewalPayLoadData.renewalTrainingInformation,
        renewalSupervisorInformation:
          renewalPayLoadData.renewalSupervisorInformation,
        renewalSignatureSubmission:
          renewalPayLoadData.renewalSignatureSubmission,
      },
      submittedBy:
        userDetails &&
        (!userDetails.roles || userDetails.roles === null) &&
        !localStorage.getItem("impersonateId")
          ? userDetails.userId || userDetails.user_id
          : adminuserDetail && adminuserDetail.userId
          ? adminuserDetail.userId
          : null,
    };
    const endpoint = "cfss/certificate/renewal";
    // const token = "";
    const headers = http.getTokenHeaders();
    return http.post(endpoint, headers, data).then((response) => {
      return response;
    });
  }
  // GET for Applicant Detials using email

  public getApplicantDetials(email: string) {
    const endpoint = `cfss/training/details`;
    const params = {
      email: email,
    };
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return response;
    });
  }

  // GET for Trining application

  public getRenewalnApplicationForm(applicationID?: string) {
    const endpoint = `cfss/certificate/renewal`;
    const params = {
      id: applicationID,
    };
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return response;
    });
  }

  // PUT for Trining application

  public updateRenewalForm(renewalPayLoadData: any, id: string) {
    const userDetails = utils.getUserDetails();
    let adminuserDetail: any = localStorage.getItem("admin_user_details");
    if (adminuserDetail) {
      adminuserDetail = JSON.parse(adminuserDetail);
    }
    const endpoint = `cfss/certificate/renewal?id=${id}`;
    const data = {
      id: id,
      fillStatus: renewalPayLoadData.fillStatus,
      data: {
        renewalApplicationInformation:
          renewalPayLoadData.renewalApplicationInformation,
        renewalTrainingInformation:
          renewalPayLoadData.renewalTrainingInformation,
        renewalSupervisorInformation:
          renewalPayLoadData.renewalSupervisorInformation,
        renewalSignatureSubmission:
          renewalPayLoadData.renewalSignatureSubmission,
      },
      submittedBy:
        userDetails &&
        (!userDetails.roles || userDetails.roles === null) &&
        !localStorage.getItem("impersonateId")
          ? userDetails.userId || userDetails.user_id
          : adminuserDetail && adminuserDetail.userId
          ? adminuserDetail.userId
          : null,
    };
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, data).then((response) => {
      return response;
    });
  }

  public updateReviewerRenewalForm(payLoadData: any, id: string) {
    const endpoint = `cfss/certificate/renewal/application`;

    const payload = {
      id: id,
      fillStatus: payLoadData.fillStatus,
      data: {
        renewalApplicationInformation:
          payLoadData.renewalApplicationInformation,
        renewalTrainingInformation: payLoadData.renewalTrainingInformation,
        renewalSupervisorInformation: payLoadData.renewalSupervisorInformation,
        renewalSignatureSubmission: payLoadData.renewalSignatureSubmission,
        History: {},
        editedComments: {},
      },
      supervisorEmails: payLoadData?.supervisorEmails,
    };
    if (payLoadData.History && payLoadData.editedComments) {
      payload.data.History = payLoadData.History;
      payload.data.editedComments = payLoadData.editedComments;
    }
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, payload).then((response) => {
      return response;
    });
  }
  public updatePeerReviewerRenewalForm(payLoadData: any, id: string) {
    const endpoint = `cfss/certificate/renewal/applicant/edit`;

    const payload = {
      id: id,
      fillStatus: payLoadData.fillStatus,
      data: {
        renewalApplicationInformation:
          payLoadData.renewalApplicationInformation,
        renewalTrainingInformation: payLoadData.renewalTrainingInformation,
        renewalSupervisorInformation: payLoadData.renewalSupervisorInformation,
        renewalSignatureSubmission: payLoadData.renewalSignatureSubmission,
        History: {},
        editedComments: {},
      },
      supervisorEmails: payLoadData?.supervisorEmails,
    };
    if (payLoadData.History && payLoadData.editedComments) {
      payload.data.History = payLoadData.History;
      payload.data.editedComments = payLoadData.editedComments;
    }
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, payload).then((response) => {
      return response;
    });
  }

  // Additional Renewaal Supervisor
  public addAdditionalRenewalSupervisor(
    additionalSupervisor: any[],
    token: string
  ) {
    const endpoint = `cfss/certificate/renewal/supervisor`;
    const payLoad = {
      data: additionalSupervisor,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
    };
    return http.put(endpoint, headers, payLoad).then((response) => {
      return response.data;
    });
  }

  // Update Renewal Supervisor status

  public updateRenewalSupervisorStatus(supervisorPayLoadData: any) {
    const endpoint = `cfss/certificate/renewal/employee/summary/status`;
    const data = {
      id: supervisorPayLoadData.id,
      email: supervisorPayLoadData.email,
      status: supervisorPayLoadData.status,
    };
    const headers = http.getTokenHeaders();
    return http.post(endpoint, headers, data).then((response) => {
      return response;
    });
  }

  // Get Renewal Supervisor List

  public getRenewalSupervisorLists(token: string) {
    const endpoint = `cfss/certificate/renewal/employee/summary/list`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
    };
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  // Inform Rejected Renewal Supervisor
  public informRejectedSupervisor(
    rejectedEmails: string[],
    applicantionId: string
  ) {
    const endpoint = `cfss/certificate/renewal/employee/summary/reject/intimate`;
    const data = {
      emailIds: rejectedEmails,
      applicationId: applicantionId,
    };
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, data).then(
      (response) => {
        return response.data;
      },
      () => Promise.resolve()
    );
  }
  public employeeRenewalResendEmail(payLoad: any) {
    const endpoint = `cfss/certificate/renewal/employee/summary/email/resend`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, payLoad).then((response) => {
      return response.data;
    });
  }
}

export const renewalFormApi = RenewalFormApi.instance;
